export const globals = {
  homepageUrl : "https://www.robertomanderioli.com"
};
